import React from "react";
import "./bouncing-loader.css";

const BouncingLoader = () => (
  <div className="bouncing-loader">
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default BouncingLoader;



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/BouncingLoader/BouncingLoader.jsx